import React, { PureComponent } from 'react';
import Icon from '../Icon';
import { Popover, Badge, Avatar } from 'antd';
import { connect, router } from 'dva';
import cx from 'classnames';
import './style/index.less';
import logoImg from 'assets/images/logo2.png';
import SearchBox from './SearchBox';
const { Link } = router;

/**
 * 其本本局头部区域
 */
@connect(({ global }) => ({ global }))
class NavBar extends PureComponent {
    state = {
        openSearchBox: false
    };

    static defaultProps = {
        fixed: true,
        theme: '' //'bg-dark',
    };

    logout = () => {

        const { dispatch } = this.props;

        dispatch({
            type: 'global/logout',
            payload: {}
        });
    }

    render() {
        const { openSearchBox } = this.state;
        const {
            fixed,
            theme,
            onCollapseLeftSide,
            collapsed,
            onExpandTopBar,
            toggleSidebarHeader,
            user,
            isMobile
        } = this.props;

        const classnames = cx('navbar', {
            'navbar-fixed-top': !!fixed,
            'navbar-sm': isMobile ? true : collapsed,
            ['bg-' + theme]: !!theme
        });

        return (
            <header className={classnames}>
                <div className="navbar-branding">
                    <Link className="navbar-brand" to="/">
                        <img src={logoImg} alt="logo" />
                        <b>TimeChart</b>
                    </Link>
                    <span className="toggle_sidemenu_l" onClick={onCollapseLeftSide}>
                        <Icon type="lines" />
                    </span>
                </div>
                <ul className="nav navbar-nav navbar-right clearfix">
                    <li>
                        <a href="https://github.com/LANIF-UI/dva-boot-admin">
                            <Icon type="GithubOutlined" antd />
                        </a>
                    </li>
                    <li className="dropdown">
                        <Popover
                            placement="bottomRight"
                            title={'通知'}
                            overlayClassName={cx('navbar-popup', { [theme]: !!theme })}
                            content={''}
                            trigger="click"
                        >
                            <a className="dropdown-toggle">
                                <Icon type="radio-tower" />
                            </a>
                        </Popover>
                    </li>
                    <li className="dropdown">
                        <Popover
                            placement="bottomRight"
                            title={`WELCOME ${user ?.username}`}
                            overlayClassName={cx('navbar-popup', { [theme]: !!theme })}
                            content={<UserDropDown logout={this.logout} />}
                            trigger="click"
                        >
                            <a className="dropdown-toggle">
                                <Badge dot>
                                    <Avatar src={require('assets/images/avatar.jpg')}>
                                        {user ?.username}
                                    </Avatar>
                                </Badge>
                            </a>
                        </Popover>
                    </li>
                </ul>
                <SearchBox visible={openSearchBox} onClose={this.onCloseSearchBox} />
            </header>
        );
    }
}

const UserDropDown = props => (
    <ul className="dropdown-menu list-group dropdown-persist">
        <li className="list-group-item">
            <a className="animated animated-short fadeInUp">
                <Icon type="ring" /> 通知
                <Badge count={5} className="label" />
            </a>
        </li>
        <li className="list-group-item">
            <a className="animated animated-short fadeInUp">
                <Icon type="gear" /> 帐户设置
            </a>
        </li>
        <li className="list-group-item dropdown-footer">
            <a onClick={props.logout}>
                <Icon type="poweroff" /> 退出
            </a>
        </li>
    </ul>
);

export default NavBar;
